var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub_visual",class:_vm.titleClass},[_c('div',{staticClass:"in"},[_c('div',{staticClass:"txt"},[_c('h2',[_vm._v(_vm._s(_vm.titleText))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }